<app-panel
  titleKey="provider.tenderResponse.projectReferences.cardTitle"
  [titleParams]="titleParams()"
>
  <div
    panelActions
    class="flex items-center gap-2"
    role="presentation"
    (click)="$event.stopPropagation()"
  >
    @if (score(); as current) {
      <p-tag severity="secondary" [value]="current.totalScore | appNumber: '1.2-2'" />
    }

    @if (isEditable()) {
      <app-model-field-select-button
        [id]="'project-reference-visibility-' + position()"
        [options]="VISIBILITY_OPTIONS"
        [allowEmpty]="false"
        [(value)]="visibility"
      />

      <app-delete-item-button
        [testId]="'project-reference-delete-' + position()"
        (delete)="onRemove()"
      />
    }
  </div>

  <div class="flex flex-col gap-4">
    <div class="grid grid-cols-1 md:grid-cols-3 gap-4">
      <app-model-field-text
        [id]="'project-reference-company-name-' + position()"
        label="common.companyName"
        tooltipKey="provider.tenderResponse.projectReferences.companyName"
        [isRequired]="true"
        [isReadOnly]="readOnly()"
        [(value)]="companyName"
      />
    </div>

    <div class="grid grid-cols-1 md:grid-cols-3 gap-4">
      <app-model-field-text
        [id]="'project-reference-project-name-' + position()"
        label="common.project.name"
        tooltipKey="provider.tenderResponse.projectReferences.projectName"
        [isRequired]="true"
        [isReadOnly]="readOnly()"
        [(value)]="projectName"
      />

      <app-model-field-datepicker
        [id]="'project-reference-start-date-' + position()"
        label="common.startDate"
        tooltipKey="provider.tenderResponse.projectReferences.startDate"
        [isRequired]="true"
        [isReadOnly]="readOnly()"
        [maxDate]="today()"
        [invalid]="isEndDateBeforeStart()"
        [(value)]="startDate"
      />

      <app-model-field-datepicker
        [id]="'project-reference-end-date-' + position()"
        label="common.endDate"
        tooltipKey="provider.tenderResponse.projectReferences.endDate"
        [isRequired]="true"
        [isReadOnly]="readOnly()"
        [minDate]="startDate()"
        [invalid]="isEndDateBeforeStart()"
        [(value)]="endDate"
      >
        <app-reference-score-badge labelBadge [scores]="scaScores()" [scaNumber]="141" />
      </app-model-field-datepicker>

      <app-model-field-number
        [id]="'project-reference-headcount-' + position()"
        label="project.steps.headcountGroup"
        tooltipKey="provider.tenderResponse.projectReferences.headcount"
        mode="integer"
        [showButtons]="true"
        [step]="50"
        [min]="1"
        [isRequired]="true"
        [isReadOnly]="readOnly()"
        [(value)]="headcount"
      >
        <app-reference-score-badge labelBadge [scores]="scaScores()" [scaNumber]="142" />
      </app-model-field-number>

      <app-model-field-select
        [id]="'project-reference-industry-' + position()"
        label="project.steps.industry"
        tooltipKey="provider.tenderResponse.projectReferences.industry"
        [options]="industryOptions()"
        [isRequired]="true"
        [isReadOnly]="readOnly()"
        [(value)]="industryId"
      >
        <app-reference-score-badge labelBadge [scores]="scaScores()" [scaNumber]="146" />
      </app-model-field-select>
    </div>

    <div class="grid grid-cols-1 md:grid-cols-3 gap-4">
      <app-model-field-multiselect
        [id]="'project-reference-countries-' + position()"
        label="multiselect.select.country"
        noSelectKey="multiselect.noSelect.country"
        tooltipKey="provider.tenderResponse.projectReferences.countries"
        [isRequired]="true"
        [isReadOnly]="readOnly()"
        [selectTranslatedOptions]="countryOptions()"
        [showCountryFlags]="true"
        [(value)]="countryCodes"
      >
        <app-reference-score-badge labelBadge [scores]="scaScores()" [scaNumber]="143" />
      </app-model-field-multiselect>
      <app-model-field-select
        [id]="'project-reference-language-' + position()"
        label="project.steps.projectLanguage"
        tooltipKey="projectSetting_projectLanguage"
        [options]="languageOptions()"
        [filter]="true"
        [isRequired]="true"
        [isReadOnly]="readOnly()"
        [(value)]="languageCode"
      >
        <app-reference-score-badge labelBadge [scores]="scaScores()" [scaNumber]="145" />
      </app-model-field-select>
      <app-functional-scope-picker
        [position]="position()"
        [moduleGroups]="moduleGroups()"
        [statusOptions]="functionStatusOptions()"
        [readOnly]="readOnly()"
        [(value)]="functionalScope"
      >
        <app-reference-score-badge labelBadge [scores]="scaScores()" [scaNumber]="144" />
      </app-functional-scope-picker>
    </div>

    @if (isSaved()) {
      <app-project-reference-document
        class="mt-4"
        [referenceId]="referenceId()"
        [position]="position()"
        [readOnly]="readOnly()"
        [(document)]="document"
        [(documentSummary)]="documentSummary"
        (documentRemoved)="onDocumentRemoved()"
      />
    }

    <app-model-field-textarea
      [id]="'project-reference-comment-' + position()"
      label="common.comment"
      tooltipKey="provider.tenderResponse.projectReferences.comment"
      [isReadOnly]="readOnly()"
      [(value)]="comment"
    />

    @if (canSave()) {
      <div class="flex justify-end">
        <p-button
          [label]="'common.save' | transloco"
          [attr.data-testid]="'project-reference-save-' + position()"
          appConfirmStepLeaveDirective
          (onClick)="onSave()"
        />
      </div>
    }
  </div>
</app-panel>
